/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingReviewSwipeRequest = {
    /**
     * Shop UUID
     */
    shopId: string;
    /**
     * Plugin product id from feed item
     */
    pluginProductId: string;
    /**
     * Analysis id from feed item (analysisId)
     */
    analysisId: string;
    /**
     * ok = acknowledged; improve = creates or updates a seller task (see GET /v2/api/tasks)
     */
    direction: ListingReviewSwipeRequest.direction;
};
export namespace ListingReviewSwipeRequest {
    /**
     * ok = acknowledged; improve = creates or updates a seller task (see GET /v2/api/tasks)
     */
    export enum direction {
        OK = 'ok',
        IMPROVE = 'improve',
    }
}

